import './_article-suggested-products.scss';
import component from './article-suggested-products';

export default component;
